export default {
  SET_GEOGRAPHIC_DIVERSIFICATION(state, payload) {
    state.countries = payload.countries;
    state.countriesMap = payload.countriesMap;
    state.countriesAsOf = payload.countriesAsOf;
    state.regions = payload.regions;
    state.regionsMap = payload.regionsMap;
    state.regionsAsOf = payload.regionsAsOf;
  }
};
